import { create } from "zustand";

const DEFAULT_DATA = {
  title: "Tab title",
  icon: "",
};

export const useAdvancedTabsSingleStore = create((set, get) => ({
  data: DEFAULT_DATA,
  setData: (value, isUndo = false, isRedo = false) => {
    const currentData = get().data;
    const newData = { ...currentData, ...value };

    if (!isUndo && !isRedo) {
      get().pushToHistory(newData);
    }

    set(() => ({
      data: newData,
    }));
  },
  getData: () => get().data,

  position: 0,
  updatePosition: (value) => {
    set(() => ({
      position: value,
    }));
  },

  history: [],
  pushToHistory: (value) => {
    const newHistory = [...get().history, value];

    set(() => ({
      history: newHistory,
      position: newHistory.length - 1,
    }));
  },

  undo: () => {
    const { history, position, setData } = get();
    setData(
      {
        ...history[position - 1],
      },
      true,
      false
    );
    set({ position: position - 1 });
  },
  redo: () => {
    const { history, position, setData } = get();
    setData(
      {
        ...history[position + 1],
      },
      false,
      true
    );
    set({ position: position + 1 });
  },

  canUndo: () => {
    const { position } = get();
    return position > 0;
  },
  canRedo: () => {
    const { history, position } = get();
    return position < history.length - 1;
  },

  resetStore: () => {
    set({
      data: DEFAULT_DATA,
      position: 0,
      history: [],
    });
  },
}));
